import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import EventBus from '@/utils/eventHub.js'
Vue.use(VueRouter)

const routes = [
{
    path: '',
    component: Layout,
    children: [{
        path: '',
        component: () => import('@/views/index/index'),
		meta: {
		  title:'首页'
		},
    },{
        path: 'store',
        component: () => import('@/views/software/index'),
		meta: {
		  title:'软件超市'
		},
    },{
        path: 'store/list',
		name: 'soft-list',
        component: () => import('@/views/software/components/list'),
		meta: {
		  title:'软件列表'
		},
    },{
        path: 'store/search',
		name: 'soft-search',
        component: () => import('@/views/software/components/searchList'),
		meta: {
		  title:'软件列表'
		},
    },{
        path: 'store/detail',
        component: () => import('@/views/software/components/pagetop'),
		children: [{
			path: ':id',
			name: 'soft-detail',
			component: () => import('@/views/software/components/detail'),
			meta: {
			  title:'软件详情'
			},
		},{
			path: 'question',
			name: 'QA-list',
			component: () => import('@/views/software/components/question'),
			meta: {
			  title:'问答'
			}
		},{
			path: 'comment',
			name: 'comment-list',
			component: () => import('@/views/software/components/comment'),
			meta: {
			  title:'点评'
			}
		}]
    },{
        path: 'store/qa-detail',
		name: 'QA-detail',
        component: () => import('@/views/software/components/QAdetail'),
		meta: {
		  title:'问答详情'
		},
    },{
        path: 'crowd',
        component: () => import('@/views/crowdSourcing/index'),
		meta: {
		  title:'众包平台'
		},
    },{
        path: 'crowd/list',
        component: () => import('@/views/crowdSourcing/list'),
        children: [{
        	path: 'expert',
        	component: () => import('@/views/crowdSourcing/components/expert'),
        	meta: {
        	  title:'行业专家'
        	}
        },{
        	path: 'demand',
        	component: () => import('@/views/crowdSourcing/components/demand'),
        	meta: {
        	  title:'任务'
        	}
        }]
    },{
        path: 'crowd/detail/expert/:id',
		name: 'expert-detail',
        component: () => import('@/views/crowdSourcing/components/expertDetail'),
		meta: {
		  title:'专家详情'
		}
    },{
        path: 'crowd/detail/demand/:id',
		name: 'demand-detail',
        component: () => import('@/views/crowdSourcing/components/demandDetail'),
		meta: {
		  title:'任务详情'
		}
    },{
        path: 'platform',
        component: () => import('@/views/platform/index'),
		meta: {
		  title:'开发平台'
		},
    },{
        path: 'login',
        component: () => import('@/views/login/index'),
		children: [{
			path: '',
			component: () => import('@/views/login/components/login'),
			meta: {
			  title:'登录'
			},
		}]
    },{
        path: 'regist',
        component: () => import('@/views/login/index'),
		children: [{
			path: '',
			component: () => import('@/views/login/components/register'),
			meta: {
			  title:'注册'
			}
		}]
    },{
        path: 'resetPass',
        component: () => import('@/views/login/index'),
		children: [{
			path: '',
			component: () => import('@/views/login/components/resetPass'),
			meta: {
			  title:'修改密码'
			}
		}]
    },{
        path: 'social',
		name: 'social',
        component: () => import('@/views/social/index'),
        meta: {
          title:'社区'
        }
    },{
        path: 'social/form',
        component: () => import('@/views/social/components/form'),
        meta: {
          title:'话题发布'
        }
    },{
        path: 'social/detail/:id',
		name: 'social-detail',
        component: () => import('@/views/social/components/detail'),
        meta: {
          title:'社区-文章详情'
        }

    },{
        path: 'case',
        component: () => import('@/views/anli/index'),
		children: [{
			path: '',
			name: 'case',
			component: () => import('@/views/anli/components/index'),
			meta: {
			  title:'案例库'
			}
		},{
			path: 'detail/:id',
			name: 'anli-detail',
			component: () => import('@/views/anli/components/detail'),
			meta: {
			  title:'案例详情'
			}
		}]
    },{
        path: 'personal',
        component: () => import('@/views/personal/index'),
		children: [{
			path: '',
			component: () => import('@/views/personal/components/settings/index'),
			children: [{
				path: 'profile',
				component: () => import('@/views/personal/components/settings/components/profile'),
				meta: {
				  title:'个人资料'
				}
			},{
				path: 'identification',
				component: () => import('@/views/personal/components/settings/components/identification'),
				meta: {
				  title:'认证'
				}
			},{
				path: 'certification',
				component: () => import('@/views/personal/components/settings/components/certification'),
				meta: {
				  title:'实名认证'
				}
			},{
				path: 'corporate',
				component: () => import('@/views/personal/components/settings/components/corporate'),
				meta: {
				  title:'企业认证'
				}
			},{
				path: 'anliManager',
				component: () => import('@/views/personal/components/settings/components/anliManager'),
				meta: {
				  title:'案例管理'
				}
			},{
				path: 'anli',
				component: () => import('@/views/personal/components/settings/components/anliForm'),
				meta: {
				  title:'案例'
				}
			},{
				path: 'anli/:id',
				name:'anliForm',
				component: () => import('@/views/personal/components/settings/components/anliForm'),
				meta: {
				  title:'案例'
				}
			},{
				path: 'account',
				component: () => import('@/views/personal/components/settings/components/account'),
				meta: {
				  title:'账号设置'
				}
			},{
				path: 'notice',
				component: () => import('@/views/personal/components/settings/components/notice'),
				meta: {
				  title:'消息通知'
				}
			},{
				path: 'identitySwitch',
				component: () => import('@/views/personal/components/settings/components/identitySwitch'),
				meta: {
				  title:'身份切换'
				}
			}]
		},{
			path: 'welfare',
			component: () => import('@/views/personal/components/welfare/index'),
			meta: {
			  title:'福利活动'
			},
			children: [{
				path: 'signin',
				component: () => import('@/views/personal/components/welfare/components/signIn'),
				meta: {
				  title:'签到'
				}
			},{
				path: 'task',
				component: () => import('@/views/personal/components/welfare/components/task'),
				meta: {
				  title:'任务中心'
				}
			},{
				path: 'exchange',
				component: () => import('@/views/personal/components/welfare/components/exchange'),
				meta: {
				  title:'福利兑换'
				}
			},{
				path: 'exchangeDetail',
				name: 'exchange-detail',
				component: () => import('@/views/personal/components/welfare/components/exchangeDetail'),
				meta: {
				  title:'福利兑换详情'
				}
			},{
				path: 'activity',
				component: () => import('@/views/personal/components/welfare/components/activity'),
				meta: {
				  title:'活动列表'
				}
			},{
				path: 'definite',
				component: () => import('@/views/personal/components/welfare/components/definite'),
				meta: {
				  title:'积分明细'
				}
			}]
		},{
			path: 'homepage',
			component: () => import('@/views/personal/components/homepage/index'),
			meta: {
			  title:'个人主页'
			},
			children: [{
				path: 'comment',
				component: () => import('@/views/personal/components/homepage/components/comment'),
				meta: {
				  title:'评论'
				}
			},{
				path: 'collection',
				component: () => import('@/views/personal/components/homepage/components/collection'),
				meta: {
				  title:'收藏'
				}
			},{
				path: 'attention',
				component: () => import('@/views/personal/components/homepage/components/attention'),
				meta: {
				  title:'关注'
				}
			},{
				path: 'draft',
				component: () => import('@/views/personal/components/homepage/components/draft'),
				meta: {
				  title:'草稿'
				}
			},{
				path: 'history',
				component: () => import('@/views/personal/components/homepage/components/history'),
				meta: {
				  title:'历史'
				}
			},{
				path: 'topic',
				component: () => import('@/views/personal/components/homepage/components/topic'),
				meta: {
				  title:'话题'
				}
			}]
		}]
    },{
        path: 'zixun',
        component: () => import('@/views/zixun/index'),
        meta: {
          title:'热点资讯'
        }
    },{
        path: 'zixun/detail/:id',
		component: () => import('@/views/zixun/components/detail'),
		meta: {
		  title:'热点资讯'
		}
    }]
}]

const originalPush = VueRouter.prototype.push
 VueRouter.prototype.push = function push(location) {
 return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	mode: 'history',
	routes
})
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title; // 设置页面标题
  }
  next();
  setTimeout(() => {
	reCal();
  }, 500)
});

export default router
